<template>
  <label class="form__checkbox form__checkbox--small">
    <input @change="change" type="checkbox"
           :id="{searchable}"
           :name="{searchable}"
           v-model="active">
      <span class="checkmark checkmark--checkbox"></span>
    {{searchable.title}}
  </label>
</template>
<script>
import {useStore} from "vuex";
import {ref, watchEffect} from "vue"

export default {
  name: 'Searchable',
  props: ['searchable'],
  setup(props) {
    const store = useStore()
    const active = ref(props.searchable.active)

    watchEffect( () => {
      const item = store.getters.activeSearchables.find( searchable => searchable === props.searchable.slug)
      active.value = !!item;
    })

    return {
      active,
      change: (e) => {
          store.dispatch('updateSearchable', {
          active: active.value,
          title: props.searchable.title,
          slug: props.searchable.slug
        })
      }
    }
  }
}
</script>
<style>
</style>
